export const CHANNELS_CONFIG = [
  {
    key: "WHATSAPP_WEB",
    title: "WhatsApp Web",
    subtitle: "Envios manuais e rápidos",
    text: "Canal simples para envios diretos via QR Code, ideal para baixo volume e interações pontuais.",
    icon: "WhatsApp",
    features: [
      "Conexão via QR Code",
      "Envios manuais ou semi-automatizados",
      "Sem aprovação de mensagens",
      "Baixo volume"
    ],
    tag: "Via QR Code",
    route: "/canais/adicionar/whatsapp-web",
  },
  {
    key: "WHATSAPP_API",
    title: "WhatsApp API",
    subtitle: "Automação e alto volume",
    text: "Canal oficial da Meta para automações, campanhas em escala e comunicações transacionais.",
    icon: "WhatsApp Business",
    features: [
      "API Oficial da Meta",
      "Alto volume de envios",
      "Automação de mensagens",
      "Uso de templates aprovados"
    ],
    tag: "API Oficial",
    route: "/canais/adicionar/whatsapp-api",
  },
  {
    key: "EMAIL",
    title: "Email",
    subtitle: "Comunicação institucional",
    text: "Canal versátil para comunicações informativas, notificações e mensagens institucionais.",
    icon: "Email",
    features: [
      "Envio em massa",
      "Conteúdo textual",
      "Canal institucional",
      "Baixo custo"
    ],
    tag: "Institucional",
    route: "/canais/adicionar/email",
  },
  {
    key: "SMS",
    title: "SMS",
    subtitle: "Mensagens curtas e diretas",
    text: "Canal rápido e confiável para alertas, códigos e comunicações urgentes.",
    icon: "SMS",
    features: [
      "Mensagens curtas",
      "Alta taxa de entrega",
      "Ideal para alertas",
      "Independente de internet"
    ],
    tag: "Notificações",
    route: "/canais/adicionar/sms",
  },
];
